import React from 'react'
import { observer } from 'mobx-react-lite'
import Joyride from 'react-joyride'
import { useStores } from '../../../../app/providers/withStore'
import TourTooltip from './TourTooltip'

const ProductTour = observer(() => {
  const { tourStore } = useStores()

  if (!tourStore) {
    return null
  }

  return (
    <Joyride
      run={tourStore.run}
      stepIndex={tourStore.stepIndex}
      steps={tourStore.steps}
      continuous
      showProgress
      showSkipButton
      tooltipComponent={TourTooltip}
      // Стили для корректного отображения кастомных подсказок
      styles={{
        // Устанавливаем z-index для всего компонента тура, чтобы он был выше других элементов интерфейса, например, sidebar.
        options: {
          zIndex: 1301, // Значение должно быть больше, чем у sidebar (у MUI Drawer обычно 1200 или 1300)
        },
        // 'floater' - это контейнер, который позиционирует подсказку.
        // Устанавливаем ему высокий z-index, чтобы он был над оверлеем.
        floater: {
          zIndex: 10000,
        },
        // Стилизуем оверлей для соответствия "стеклянному" дизайну
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(3px)', // Возвращаем размытие на оверлей
        },
        // Убираем фон у стандартного контейнера подсказки,
        // так как наш кастомный компонент TourTooltip имеет свой фон.
        tooltip: {
          backgroundColor: 'transparent',
        },
      }}
      callback={tourStore.handleJoyrideCallback}
      locale={{
        back: 'Назад',
        close: 'Закрыть',
        last: 'Готово',
        next: 'Далее',
        skip: 'Пропустить',
      }}
    />
  )
})

export default ProductTour
